var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgAgenda = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 497 497",
    height: 512,
    viewBox: "0 0 497 497",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m425 48v439c0 5.52-4.48 10-10 10h-333c-5.52 0-10-4.48-10-10v-439c0-5.52 4.48-10 10-10h333c5.52 0 10 4.48 10 10z",
    fill: "#fad207"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m88 87.349v386.57c0 3.911 3.17 7.081 7.081 7.081h201.777c2.652 0 5.196-1.054 7.071-2.929l77.071-77.071v-319h-273.074l-1.686-12.171-13.79 9.202c-2.781 1.855-4.45 4.976-4.45 8.318z",
    fill: "#faa515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m395 78v309l-60 22-20 58h-203c-5.523 0-10-4.477-10-10v-379c0-5.523 4.477-10 10-10h273c5.523 0 10 4.477 10 10z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m395 387-80 80v-70c0-5.523 4.477-10 10-10z",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m349.14 68v19.43c0 13.78-11.22 25-25 25h-151.28c-13.78 0-25-11.22-25-25v-19.43z",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m147.86 38h201.28v30h-201.28z",
    fill: "#faa515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m334.138 37.979v49.447c0 5.523-4.477 10-10 10h-151.276c-5.523 0-10-4.477-10-10v-49.447l55.507.001c-.738-3.171-.989-6.529-.669-9.991 1.382-14.945 13.632-26.88 28.605-27.913 18.078-1.247 33.13 13.049 33.13 30.86 0 2.423-.279 4.782-.806 7.044z",
    fill: "#50758d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m171.891 198.096c-1.935 0-3.799-.748-5.198-2.094l-25.337-24.362c-2.986-2.871-3.079-7.619-.208-10.604s7.62-3.078 10.604-.208l19.689 18.933 30.877-35.051c2.737-3.107 7.477-3.409 10.586-.67 3.107 2.738 3.408 7.478.67 10.586l-36.056 40.929c-1.353 1.535-3.273 2.451-5.317 2.535-.103.004-.207.006-.31.006z",
    fill: "#5ed297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m344 177.631h-106c-4.143 0-7.5-3.357-7.5-7.5s3.357-7.5 7.5-7.5h106c4.143 0 7.5 3.357 7.5 7.5s-3.357 7.5-7.5 7.5z",
    fill: "#50758d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m171.891 286.327c-1.935 0-3.799-.748-5.198-2.094l-25.337-24.362c-2.986-2.871-3.079-7.619-.208-10.604 2.871-2.986 7.62-3.079 10.604-.208l19.701 18.943 30.929-34.971c2.743-3.103 7.483-3.394 10.587-.649 3.103 2.744 3.394 7.484.649 10.587l-36.109 40.827c-1.354 1.53-3.273 2.442-5.315 2.525-.101.004-.203.006-.303.006z",
    fill: "#5ed297"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#50758d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m344 265.5h-106c-4.143 0-7.5-3.357-7.5-7.5s3.357-7.5 7.5-7.5h106c4.143 0 7.5 3.357 7.5 7.5s-3.357 7.5-7.5 7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m344 356.631h-17.5c-4.143 0-7.5-3.357-7.5-7.5s3.357-7.5 7.5-7.5h17.5c4.143 0 7.5 3.357 7.5 7.5s-3.357 7.5-7.5 7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m291.5 356.631h-53.5c-4.143 0-7.5-3.357-7.5-7.5s3.357-7.5 7.5-7.5h53.5c4.143 0 7.5 3.357 7.5 7.5s-3.357 7.5-7.5 7.5z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m199 379.631h-46c-4.143 0-7.5-3.357-7.5-7.5v-46c0-4.143 3.357-7.5 7.5-7.5h46c4.143 0 7.5 3.357 7.5 7.5v46c0 4.142-3.357 7.5-7.5 7.5zm-38.5-15h31v-31h-31z",
    fill: "#fd646f"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAgenda, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/agenda.09775d1b.svg";
export { ForwardRef as ReactComponent };